/**
 * @generated SignedSource<<72f0102a70ed58d52179ee130290c15e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type singleSelect_issueFieldSingleSelectReadviewFull_SingleSelectReadView$data = {
  readonly fieldOption: {
    readonly color: {
      readonly colorKey: string | null | undefined;
    } | null | undefined;
    readonly value: string | null | undefined;
  } | null | undefined;
  readonly fieldOptions?: {
    readonly totalCount: number | null | undefined;
  } | null | undefined;
  readonly id?: string;
  readonly " $fragmentType": "singleSelect_issueFieldSingleSelectReadviewFull_SingleSelectReadView";
};
export type singleSelect_issueFieldSingleSelectReadviewFull_SingleSelectReadView$key = {
  readonly " $data"?: singleSelect_issueFieldSingleSelectReadviewFull_SingleSelectReadView$data;
  readonly " $fragmentSpreads": FragmentRefs<"singleSelect_issueFieldSingleSelectReadviewFull_SingleSelectReadView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "singleSelect_issueFieldSingleSelectReadviewFull_SingleSelectReadView",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "concreteType": "JiraOptionConnection",
          "kind": "LinkedField",
          "name": "fieldOptions",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "totalCount"
            }
          ]
        }
      ]
    },
    {
      "concreteType": "JiraOption",
      "kind": "LinkedField",
      "name": "fieldOption",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "value"
        },
        {
          "concreteType": "JiraColor",
          "kind": "LinkedField",
          "name": "color",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "colorKey"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraSingleSelectField"
};

(node as any).hash = "4719cfe591e56918754591749ccec2fd";

export default node;
